import React from 'react';

const UnusedFormConfirmationWarning = ({ onConfirm }) => (
  <div className="unused-form-confirmation-warning-content">
    <div className="heads-up-icon svg-ico-lightbulb" />
    <div>
      <span className="unused-form-confirmation-warning-label">Note:</span>
      This Form Confirmation Dialog is not currently in use. If you would like this to be displayed
      to your users after they successfully submit your form, either click the button below or
      select the form and choose &ldquo;Show form confirmation dialog&rdquo; in the
      &ldquo;Confirmation&rdquo; drop-down menu in the form&lsquo;s properties panel. You can edit
      this dialog just like any other page.
      <a className="button" onClick={onConfirm}>
        Use this as my form confirmation
      </a>
    </div>
  </div>
);

UnusedFormConfirmationWarning.propTypes = {
  onConfirm: React.PropTypes.func,
};

export default UnusedFormConfirmationWarning;



// WEBPACK FOOTER //
// ./src/ui/components/unused-form-confirmation-warning.jsx